module.exports = __webpack_public_path__ + "static/media/phone-number-icon.eb8ad26b.svg";